export enum TaxonomicRank {
  KINGDOM = "kingdom",
  PHYLUM = "phylum",
  CLASS = "class",
  ORDER = "order",
  FAMILY = "family",
  GENUS = "genus",
  SPECIES = "species",
  SUBSPECIES = "subspecies",
  VARIETY_GROUP = "variety_group",
  VARIETY = "variety",
  FORM = "form",
}
